import { useState } from 'react'
import { v4 as uuidv4 } from 'uuid'

import partner1 from '@/assets/images/partners/logo-partner1.svg'

import styles from './Partners.module.scss'

const partners = [
  {
    id: uuidv4(),
    logo: partner1,
    link: 'https://www.gazprombank.ru/',
    adInfo: {
      company: 'БАНК ГПБ (АО)',
      inn: '7744001497',
      token: '2VtzqwfbncN',
    },
  },
]

function Partner({ data }) {
  const [isVisibleInfo, setIsVisibleInfo] = useState(false)

  const handleClickAdInfo = (evt) => {
    evt.preventDefault()

    setIsVisibleInfo(!isVisibleInfo)
  }

  return (
    <a {...(data.hasOwnProperty('link') && { href: data.link })}>
      <div className={styles.partner}>
        <img src={data.logo} className={styles.logo} alt="" />

        {isVisibleInfo && (
          <div className={styles.partnerInfo} onClick={(evt) => evt.preventDefault()}>
            <p>{data?.adInfo?.company}</p>
            <p>ИНН: {data?.adInfo?.inn}</p>
            <p>ERID: {data?.adInfo?.token}</p>
          </div>
        )}

        {Object.keys(data?.adInfo).length > 0 && (
          <button className={styles.infoToggle} onClick={handleClickAdInfo}>
            <span className="visually-hidden">
              {isVisibleInfo ? 'Скрыть' : 'Показать'} дополнительную информацию
            </span>
          </button>
        )}
      </div>
    </a>
  )
}

function Partners() {
  return (
    <section className={styles.partners}>
      <div className={styles.top}>
        <p className={styles.counter}>04/</p>

        <h2 className={styles.title}>Партнёры</h2>
      </div>

      <div className={styles.list}>
        {partners.map((item) => (
          <Partner data={item} key={item.id} />
        ))}
      </div>
    </section>
  )
}

export default Partners
